/* tops the family carousel past the 250 collection cap */

(function () {
  'use strict';

  var VIEW = 'shop-collection';
  // matches the server path's paginate ceiling
  var MAX_CELLS = 250;
  var TIMEOUT_MS = 6000;

  // every exit has to clear the loader
  function finish(wrap) {
    if (wrap.__familyFinished) return;
    wrap.__familyFinished = true;

    var list = wrap.querySelector('.ProductList--carousel');
    var hasCells = list && list.querySelector('[data-product-handle]');
    if (hasCells) wrap.classList.remove('is-empty');
    else wrap.classList.add('is-empty');

    wrap.classList.add('is-loaded');
  }

  function clearAll() {
    var wraps = document.querySelectorAll('[data-family-carousel]');
    for (var i = 0; i < wraps.length; i++) finish(wraps[i]);
  }

  if (!window.XMLHttpRequest || !window.DOMParser) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', clearAll);
    } else {
      clearAll();
    }
    return;
  }

  function requestOnce(url, tries) {
    // xhr avoids app fetch wrappers
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.timeout = 3000;
      xhr.setRequestHeader('Accept', 'text/html');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseText);
        } else {
          reject(new Error('HTTP ' + xhr.status));
        }
      };
      xhr.onerror = function () { reject(new Error('Network error')); };
      xhr.ontimeout = function () { reject(new Error('Request timeout')); };
      xhr.send();
    })
      ['catch'](function (err) {
        if (tries > 0) return requestOnce(url, tries - 1);
        throw err;
      });
  }

  function fireResize() {
    var evt;
    try {
      evt = new Event('resize');
    } catch (e) {
      evt = document.createEvent('Event');
      evt.initEvent('resize', true, true);
    }
    window.dispatchEvent(evt);
  }

  function quoteField(value) {
    return '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  }

  /* both calls were made before these extra products */
  function reveal(wrap, list) {
    wrap.classList.remove('is-empty');

    var perRow = parseInt(wrap.getAttribute('data-rec-per-row-desktop'), 10) || 5;
    var total = list.querySelectorAll('.Carousel__Cell').length;

    // static rows drop flickity and stay centred
    if (total > 0 && total <= perRow) {
      wrap.classList.add('rec-wrap--static');
    } else {
      wrap.classList.remove('rec-wrap--static');
    }
  }

  function topUp(wrap) {
    if (wrap.__familyDone) return;
    wrap.__familyDone = true;

    var word = (wrap.getAttribute('data-family-word') || '').trim();
    var vendor = (wrap.getAttribute('data-family-vendor') || '').trim();
    var current = wrap.getAttribute('data-family-handle') || '';
    var list = wrap.querySelector('.ProductList--carousel');

    if (!list || !word || !vendor) {
      finish(wrap);
      return;
    }

    // never strand the spinner
    var timer = setTimeout(function () { finish(wrap); }, TIMEOUT_MS);

    // whatever liquid already rendered wins, we only fill gaps
    var seen = {};
    seen[current] = true;
    Array.prototype.forEach.call(list.querySelectorAll('[data-product-handle]'), function (cell) {
      seen[cell.getAttribute('data-product-handle')] = true;
    });

    var query = 'vendor:' + quoteField(vendor) + ' title:' + quoteField(word);
    var url = '/search?q=' + encodeURIComponent(query) +
      '&type=product&options[prefix]=last&view=' + VIEW;

    requestOnce(url, 1)
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var found = parsed.querySelectorAll('[data-family-cell]');
        var existing = list.querySelectorAll('.Carousel__Cell').length;
        var add = [];

        Array.prototype.forEach.call(found, function (cell) {
          if (existing + add.length >= MAX_CELLS) return;
          var handle = cell.getAttribute('data-product-handle');
          if (!handle || seen[handle]) return;
          if (cell.getAttribute('data-product-vendor') !== vendor) return;
          seen[handle] = true;
          add.push(document.importNode(cell, true));
        });

        if (!add.length) {
          clearTimeout(timer);
          finish(wrap);
          return;
        }

        var flkty = window.Flickity && window.Flickity.data ? window.Flickity.data(list) : null;

        if (flkty && list.classList.contains('flickity-enabled')) {
          /* flickity owns its cells once active */
          flkty.append(add);
        } else {
          add.forEach(function (node) { list.appendChild(node); });
        }

        reveal(wrap, list);
        clearTimeout(timer);
        finish(wrap);

        if (flkty) {
          try { flkty.resize(); } catch (e) {}
        }
        // re-activates flickity if static just came off
        fireResize();
      })
      ['catch'](function () {
        /* keep the server-rendered cells */
        clearTimeout(timer);
        finish(wrap);
      });
  }

  function run() {
    var wraps = document.querySelectorAll('[data-family-carousel]');
    for (var i = 0; i < wraps.length; i++) topUp(wraps[i]);
  }

  function idle(fn) {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 1500 });
    else setTimeout(fn, 200);
  }

  /* a hidden wrap never trips an observer */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { idle(run); });
  } else {
    idle(run);
  }
})();
